<template>
    <div class="block lg:hidden fixed top-0 left-0 w-screen h-screen bg-white z-10 p-4 pt-32 overflow-y-auto flex flex-col">
      <div class="mb-4 mt-2 border-b border-black">
        <MenuDropdown 
          class="w-full" 
          v-for="(menuItem, index) in mainMenu.items" 
          :menuItem="menuItem" 
          :key="index"
          />
      </div>
      
      <div class="footermenu flex justify-between py-6 w-full mt-auto">
        <div v-for="(item, index) in footerMenu.items" :key="item.url">
          <NuxtLink :to="menuStore.stripDomain(item.url)" class="underline">
            {{ item.title }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </template>

<script setup>
import { useMenuStore } from "@/stores/menuStore";
const menuStore = useMenuStore();

const props = defineProps({
    mainMenu: {
        type: Object,
        required: true
    },
    footerMenu: {
        type: Object,
        required: true
    }
})
</script>

<style scoped>
/* Add your styles here */
</style>